import LabelledElement from "./LabelledElement";
import { InputAdornment } from "@mui/material";
import PrettyNumberTextField from "components/common/PrettyNumberTextField";

const NumberElement = ({ label, value, onChange, prefix }) => {
  return (
    <LabelledElement label={label}>
      <PrettyNumberTextField
        variant={"outlined"}
        size={"small"}
        value={value}
        onChangeNumber={onChange}
        InputProps={{
          startAdornment: prefix ? (
            <InputAdornment position={"start"}>{prefix}</InputAdornment>
          ) : null,
        }}
      />
    </LabelledElement>
  );
};

export default NumberElement;
